var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLvlUpMedalTag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 324.948,
    height: 86.724,
    viewBox: "0 0 324.948 86.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1225",
    "data-name": "Rectangle 1225",
    width: 324.948,
    height: 86.724,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1218",
    "data-name": "Rectangle 1218",
    width: 69.83,
    height: 61.301,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1219",
    "data-name": "Rectangle 1219",
    width: 69.831,
    height: 61.301,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1220",
    "data-name": "Rectangle 1220",
    width: 29.516,
    height: 31.6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1221",
    "data-name": "Rectangle 1221",
    width: 29.516,
    height: 31.594,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1222",
    "data-name": "Rectangle 1222",
    width: 244.34,
    height: 63.492,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1223",
    "data-name": "Rectangle 1223",
    width: 122.366,
    height: 63.491,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3105",
    "data-name": "Group 3105",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2798",
    "data-name": "Group 2798",
    transform: "translate(0 -0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2797",
    "data-name": "Group 2797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2796",
    "data-name": "Group 2796",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2780",
    "data-name": "Group 2780",
    transform: "translate(255.117 25.423)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2779",
    "data-name": "Group 2779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2778",
    "data-name": "Group 2778",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32236",
    "data-name": "Path 32236",
    d: "M470.021,88.928a313.874,313.874,0,0,1-66.662,12.049c-1.052.076-2.1.14-3.149.2h-.019V51.533a225.184,225.184,0,0,0,66.72-11.653l-18.7,29.05Z",
    transform: "translate(-400.191 -39.88)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_32237",
    "data-name": "Path 32237",
    d: "M470.021,84.928a313.875,313.875,0,0,1-66.662,12.049c-1.052.076-2.1.14-3.149.2h-.019V47.533a225.184,225.184,0,0,0,66.72-11.653l-18.7,29.05Z",
    transform: "translate(-145.074 -13.007)",
    fill: "#de3622"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2783",
    "data-name": "Group 2783",
    transform: "translate(0.003 25.423)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2782",
    "data-name": "Group 2782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2781",
    "data-name": "Group 2781",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32238",
    "data-name": "Path 32238",
    d: "M0,88.928a313.875,313.875,0,0,0,66.662,12.049c1.052.076,2.1.14,3.149.2h.019V51.533A225.176,225.176,0,0,1,3.116,39.88l18.7,29.05Z",
    transform: "translate(-0.004 -39.88)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_32239",
    "data-name": "Path 32239",
    d: "M69.831,47.537V97.185h-.018c-1.046-.064-2.092-.128-3.137-.2h-.013A313.874,313.874,0,0,1,0,84.932l21.808-20-18.7-29.05a225.188,225.188,0,0,0,66.72,11.653",
    transform: "translate(0 -13.008)",
    fill: "#de3622"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2786",
    "data-name": "Group 2786",
    transform: "translate(40.315 52.577)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2785",
    "data-name": "Group 2785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2784",
    "data-name": "Group 2784",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32240",
    "data-name": "Path 32240",
    d: "M92.756,113.7v.376h-.018c-1.046-.064-2.092-.127-3.137-.2L63.279,85.7l-.039-3.226,29.375,5.043Z",
    transform: "translate(-63.24 -82.475)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2789",
    "data-name": "Group 2789",
    transform: "translate(255.136 52.58)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2788",
    "data-name": "Group 2788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2787",
    "data-name": "Group 2787",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32241",
    "data-name": "Path 32241",
    d: "M429.737,85.667l-.038.032L403.37,113.87c-1.052.076-2.1.14-3.149.2l.14-26.558,29.375-5.036Z",
    transform: "translate(-400.221 -82.48)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_32242",
    "data-name": "Path 32242",
    d: "M429.726,82.48l-.039.032-29.5,31.565.159-29.748,29.337-1.842Z",
    transform: "translate(-145.074 -29.9)",
    fill: "#ba2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32243",
    "data-name": "Path 32243",
    d: "M63.241,82.476l29.518,31.6L92.6,84.328Z",
    transform: "translate(-22.926 -29.899)",
    fill: "#ba2d1d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2792",
    "data-name": "Group 2792",
    transform: "translate(40.314 3.187)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2791",
    "data-name": "Group 2791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2790",
    "data-name": "Group 2790",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32244",
    "data-name": "Path 32244",
    d: "M301.45,5C254.407,19.527,115.887,19.505,69.368,5l-6.13,49.4,0,3.18c61.159,14.512,182.373,14.593,244.339,0l0-3.186Z",
    transform: "translate(-63.238 -5)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_32245",
    "data-name": "Path 32245",
    d: "M301.451,0C254.408,14.527,115.888,14.505,69.369,0L63.241,52.578c61.159,14.512,182.373,14.593,244.339,0Z",
    transform: "translate(-22.926)",
    fill: "#ea3924"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2795",
    "data-name": "Group 2795",
    transform: "translate(40.315)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794",
    "data-name": "Group 2794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2793",
    "data-name": "Group 2793",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32246",
    "data-name": "Path 32246",
    d: "M69.369,0,63.241,52.578c30.691,7.282,76.505,10.93,122.366,10.913v-52.6C139.15,10.9,92.694,7.273,69.369,0",
    transform: "translate(-63.241)",
    fill: "#fff"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLvlUpMedalTag);
export default __webpack_public_path__ + "static/media/lvlUpMedalTag.fb614056227888708c67211b4c63ae36.svg";
export { ForwardRef as ReactComponent };